import { render, staticRenderFns } from "./NoMasEnviosPostales2.vue?vue&type=template&id=269f0f10&scoped=true&"
import script from "./NoMasEnviosPostales2.vue?vue&type=script&lang=js&"
export * from "./NoMasEnviosPostales2.vue?vue&type=script&lang=js&"
import style0 from "./NoMasEnviosPostales2.vue?vue&type=style&index=0&id=269f0f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269f0f10",
  null
  
)

export default component.exports